// Global
import React from 'react';

// Local
import styles from './ContentBlock.module.scss';
import clsx from 'clsx';
import { useSearchResultsFallbackContent } from '../SearchResults/SearchResultsFallbackContentContext';
import { useRouter } from 'next/router';
import { useSitecorePage } from 'lib/hooks/sitecore/useSitecorePage';

type RouteComponent = {
  componentName?: string;
  placeholders?: Record<string, unknown>;
};

const containsSearchResults = (component: unknown): boolean => {
  if (!component || typeof component !== 'object') {
    return false;
  }

  const routeComponent = component as RouteComponent;
  if (routeComponent.componentName === 'SearchResults') {
    return true;
  }

  return Object.values(routeComponent.placeholders ?? {}).some(
    (placeholder) => Array.isArray(placeholder) && placeholder.some(containsSearchResults)
  );
};

export interface ContentBlockProps {
  className?: string;
  text: React.ReactNode;
}

export const ContentBlock = (props: ContentBlockProps) => {
  /*
   * Rendering
   */
  const { fallbackContentState } = useSearchResultsFallbackContent();
  const router = useRouter();
  const page = useSitecorePage();
  const hasRuntimeSearchTerm =
    router.isReady && typeof router.query.term === 'string' && !!router.query.term.trim();
  const isSearchResultsFallbackCandidate = hasRuntimeSearchTerm && containsSearchResults(page);

  if (
    fallbackContentState === 'hidden' ||
    (isSearchResultsFallbackCandidate && fallbackContentState !== 'visible')
  ) {
    return null;
  }

  return <div className={clsx(styles.contentBlock, props.className)}>{props.text}</div>;
};
